var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "wkb-explain-backdrop",
          attrs: { role: "presentation" },
          on: { click: _vm.onBackdropClick },
        },
        [
          _c(
            "div",
            {
              staticClass: "wkb-explain-modal",
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "wkb-explain-title",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("header", { staticClass: "wkb-explain-head" }, [
                _c("div", { staticClass: "wkb-explain-head-row" }, [
                  _c("h2", { attrs: { id: "wkb-explain-title" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.isViewMode ? "Graph explanation" : "Explain graph"
                      )
                    ),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "wkb-explain-close",
                      attrs: {
                        type: "button",
                        "aria-label": "Close",
                        disabled: _vm.loading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_vm._v(" × ")]
                  ),
                ]),
                !_vm.isViewMode
                  ? _c("p", { staticClass: "wkb-explain-intro" }, [
                      _vm._v(
                        " Generate an LLM summary of the current graph. Edit the question and context before running. "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "wkb-explain-body" }, [
                !_vm.isViewMode && !_vm.scopeLocked
                  ? _c(
                      "fieldset",
                      {
                        staticClass: "wkb-explain-scope",
                        attrs: { disabled: _vm.loading },
                      },
                      [
                        _c(
                          "legend",
                          { staticClass: "wkb-explain-scope-legend" },
                          [_vm._v("Explain scope")]
                        ),
                        _c(
                          "label",
                          { staticClass: "wkb-explain-scope-option" },
                          [
                            _c("input", {
                              attrs: {
                                type: "radio",
                                name: "wkb-explain-scope",
                              },
                              domProps: {
                                value: _vm.scopeKeyNodes,
                                checked: _vm.scope === _vm.scopeKeyNodes,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$emit(
                                    "update:scope",
                                    _vm.scopeKeyNodes
                                  )
                                },
                              },
                            }),
                            _c(
                              "span",
                              { staticClass: "wkb-explain-scope-copy" },
                              [
                                _c("strong", [_vm._v("Selected nodes only")]),
                                _c(
                                  "span",
                                  { staticClass: "wkb-explain-scope-meta" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.keyNodeCount) +
                                        " selected node" +
                                        _vm._s(
                                          _vm.keyNodeCount === 1 ? "" : "s"
                                        ) +
                                        " on canvas "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "label",
                          { staticClass: "wkb-explain-scope-option" },
                          [
                            _c("input", {
                              attrs: {
                                type: "radio",
                                name: "wkb-explain-scope",
                              },
                              domProps: {
                                value: _vm.scopeEntireGraph,
                                checked: _vm.scope === _vm.scopeEntireGraph,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$emit(
                                    "update:scope",
                                    _vm.scopeEntireGraph
                                  )
                                },
                              },
                            }),
                            _c(
                              "span",
                              { staticClass: "wkb-explain-scope-copy" },
                              [
                                _c("strong", [_vm._v("All visible nodes")]),
                                _c(
                                  "span",
                                  { staticClass: "wkb-explain-scope-meta" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.nodeCount) +
                                        " node" +
                                        _vm._s(_vm.nodeCount === 1 ? "" : "s") +
                                        ", " +
                                        _vm._s(_vm.edgeCount) +
                                        " edge" +
                                        _vm._s(_vm.edgeCount === 1 ? "" : "s") +
                                        " "
                                    ),
                                    _vm.contextualEdgeCount
                                      ? [
                                          _vm._v(
                                            " (+ " +
                                              _vm._s(_vm.contextualEdgeCount) +
                                              " contextual) "
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                !_vm.isViewMode && _vm.helperText
                  ? _c("p", { staticClass: "wkb-explain-helper" }, [
                      _vm._v(_vm._s(_vm.helperText)),
                    ])
                  : _vm._e(),
                !_vm.isViewMode && !_vm.llmAvailable
                  ? _c(
                      "p",
                      {
                        staticClass: "wkb-explain-llm-note",
                        attrs: { role: "note" },
                      },
                      [
                        _vm._v(
                          " LLM explanation is not available — the interactive API did not report an LLM backend. "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.loading
                  ? _c(
                      "div",
                      {
                        staticClass: "wkb-explain-loading",
                        attrs: { role: "status" },
                      },
                      [
                        _c("span", {
                          staticClass: "wkb-explain-spinner",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._m(0),
                      ]
                    )
                  : _vm.entry &&
                    _vm.entry.status === "success" &&
                    _vm.entry.interpretation
                  ? _c(
                      "div",
                      { staticClass: "wkb-explain-result" },
                      [
                        _c("div", { staticClass: "wkb-explain-result-head" }, [
                          _c(
                            "span",
                            { staticClass: "wkb-explain-result-label" },
                            [_vm._v("Explanation")]
                          ),
                          _vm.entry.timestamp_label
                            ? _c(
                                "span",
                                { staticClass: "wkb-explain-result-meta" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.entry.timestamp_label) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _c("WorkspaceMarkdownBlock", {
                          attrs: { text: _vm.displayInterpretation },
                        }),
                        _vm.entry.prompt_preview
                          ? _c(
                              "details",
                              { staticClass: "wkb-explain-prompt" },
                              [
                                _c("summary", [_vm._v("See prompt")]),
                                _c(
                                  "pre",
                                  { staticClass: "wkb-explain-prompt-pre" },
                                  [_vm._v(_vm._s(_vm.entry.prompt_preview))]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showKeyNodeSuggestions
                  ? _c(
                      "section",
                      {
                        staticClass: "wkb-explain-suggestions",
                        attrs: { "aria-label": "Suggested selected nodes" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "wkb-explain-suggestions-head" },
                          [
                            _c(
                              "h3",
                              { staticClass: "wkb-explain-suggestions-title" },
                              [_vm._v("Suggested selected nodes")]
                            ),
                            _vm.addableSuggestionCount
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "wkb-explain-btn wkb-explain-btn-primary wkb-explain-suggestions-batch",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit(
                                          "add-all-suggested-key-nodes"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " Add all (" +
                                        _vm._s(_vm.addableSuggestionCount) +
                                        ") "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "p",
                          { staticClass: "wkb-explain-suggestions-intro" },
                          [
                            _vm._v(
                              " From the LLM explanation — add nodes to your selected set for hypothesis work. "
                            ),
                          ]
                        ),
                        _c(
                          "ul",
                          { staticClass: "wkb-explain-suggestions-list" },
                          _vm._l(_vm.keyNodeSuggestions, function (item) {
                            return _c(
                              "li",
                              {
                                key: item.node_id,
                                staticClass: "wkb-explain-suggestion-item",
                                class: { "is-key-node": item.is_key_node },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "wkb-explain-suggestion-main",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "wkb-explain-suggestion-label",
                                      },
                                      [_vm._v(_vm._s(item.label))]
                                    ),
                                    item.node_type
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "wkb-explain-suggestion-type",
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.node_type) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    item.is_key_node
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "wkb-explain-suggestion-badge",
                                          },
                                          [_vm._v(" Selected node ")]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                item.rationale
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "wkb-explain-suggestion-rationale",
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(item.rationale) + " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "button",
                                  {
                                    staticClass: "wkb-explain-suggestion-add",
                                    attrs: {
                                      type: "button",
                                      disabled: item.is_key_node,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit(
                                          "add-suggested-key-node",
                                          item.node_id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.is_key_node
                                            ? "Already a selected node"
                                            : "Add as selected node"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    )
                  : _vm.entry && _vm.entry.status === "error"
                  ? _c(
                      "div",
                      {
                        staticClass: "wkb-explain-error",
                        attrs: { role: "alert" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.entry.error || "Explanation failed.") +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
                !_vm.loading && (!_vm.entry || _vm.entry.status !== "success")
                  ? _c("div", { staticClass: "wkb-explain-form" }, [
                      _c(
                        "label",
                        {
                          staticClass: "wkb-explain-label",
                          attrs: { for: "wkb-explain-query" },
                        },
                        [_vm._v(" Query sent to the LLM ")]
                      ),
                      _c("textarea", {
                        staticClass: "wkb-explain-textarea",
                        attrs: {
                          id: "wkb-explain-query",
                          rows: "5",
                          placeholder: "Question to ask the LLM",
                          disabled: _vm.loading || !_vm.entry,
                        },
                        domProps: {
                          value: _vm.entry ? _vm.entry.query_text : "",
                        },
                        on: { input: _vm.onQueryInput },
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "wkb-explain-label",
                          attrs: { for: "wkb-explain-context" },
                        },
                        [_vm._v(" Additional intent / context ")]
                      ),
                      _c("textarea", {
                        staticClass: "wkb-explain-textarea",
                        attrs: {
                          id: "wkb-explain-context",
                          rows: "3",
                          placeholder:
                            "Optional context or intent to add to the prompt",
                          disabled: _vm.loading || !_vm.entry,
                        },
                        domProps: {
                          value: _vm.entry ? _vm.entry.additional_context : "",
                        },
                        on: { input: _vm.onContextInput },
                      }),
                    ])
                  : _vm._e(),
                !_vm.isViewMode && !_vm.loading
                  ? _c("div", { staticClass: "wkb-explain-actions" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "wkb-explain-btn wkb-explain-btn-primary",
                          attrs: { type: "button", disabled: !_vm.canRun },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("run")
                            },
                          },
                        },
                        [_vm._v(" Run LLM ")]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("strong", [_vm._v("Generating explanation…")]),
      _c("p", [_vm._v("This may take a moment.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }